// XOL-235: does deleting this organisation need the typed word "delete"?
//
// The API decides (xolas-tms-api #300: an org whose delete would remove or unlink anything —
// activity, contacts, attachments, child orgs, rates, workflows, shared-asset links, … — refuses
// DELETE /org/{id} without the JSON body { delete: 'delete' }) and exposes the answer as the
// boolean `deleteRequiresConfirm` on GET /org and GET /org/{id}. Against an API that predates
// the field the key is absent, so this falls back to the old rule (`active > 0`) and behaviour
// is unchanged. Used by OrgControls (the row trash can is disabled for such an org) and by
// OrgDetail (the Activity tab, which holds Delete ALL, is shown for such an org).
export function orgDeleteNeedsConfirm (org) {
  if (!org) return false
  if (org.deleteRequiresConfirm !== undefined) return !!org.deleteRequiresConfirm
  return Number(org.active) > 0
}
